<template>
  <div class="bid-notify-settings">
    <van-nav-bar
      title="中单通知"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      fixed
      :placeholder="true"
    />

    <div class="settings-content">
      <!-- 中单通知设置 -->
      <div class="settings-section">
        <div class="section-header">
          <div class="section-icon">🎯</div>
          <div class="section-title">中单通知</div>
        </div>
        <div class="settings-list">
          <van-cell
            title="语音提醒"
            label="中标时播放语音提示"
            center
          >
            <template #right-icon>
              <van-switch
                v-model="autoAlarmBidOrder"
                size="24"
                @change="setAuto(2)"
              />
            </template>
          </van-cell>
          <van-cell
            title="微信通知"
            label="中标时发送微信消息"
            center
          >
            <template #right-icon>
              <van-switch
                v-model="autoWxAlarmBidOrder"
                size="24"
                @change="setAuto(5)"
              />
            </template>
          </van-cell>
        </div>
      </div>

      <!-- 设置说明 -->
      <div class="settings-tips">
        <div class="tips-header">
          <van-icon name="info-o" color="#1989fa" />
          <span>设置说明</span>
        </div>
        <div class="tips-content">
          <p>• 语音提醒：在手机端播放提示音</p>
          <p>• 微信通知：通过微信发送消息提醒</p>
          <p>• 建议同时开启语音和微信通知，确保及时收到中标消息</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: 'BidNotifySettings',
  data() {
    return {
      autoAlarmBidOrder: false,
      autoWxAlarmBidOrder: false
    }
  },
  created() {
    this.loadSettings()
  },
  methods: {
    goBack() {
      this.$router.back()
    },

    loadSettings() {
      const userInfo = this.$store.state.user.userInfo
      this.autoAlarmBidOrder = userInfo.alarm_type === 1
      this.autoWxAlarmBidOrder = userInfo.wx_bid_order_type === 1
    },

    setAuto(item) {
      let data = {}
      if (item === 2) {
        data.alarm_type = this.autoAlarmBidOrder ? 1 : 2
      } else if (item === 5) {
        data.wx_bid_order_type = this.autoWxAlarmBidOrder ? 1 : 2
      }

      Api.setAutoStatus(data).then(() => {
        this.$toast.success('设置成功')
        const userInfo = { ...this.$store.state.user.userInfo }
        if (item === 2) userInfo.alarm_type = data.alarm_type
        else if (item === 5) userInfo.wx_bid_order_type = data.wx_bid_order_type
        this.$store.commit('setUserInfo', userInfo)
      }).catch(() => {
        this.$toast.fail('设置失败，请重试')
        this.loadSettings()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-notify-settings {
  background-color: #f7f7fa;
  min-height: 100vh;

  .settings-content {
    padding: 16px;

    .settings-section {
      background: white;
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      overflow: hidden;

      .section-header {
        display: flex;
        align-items: center;
        padding: 20px 16px 16px 16px;
        border-bottom: 1px solid #f5f5f5;

        .section-icon {
          font-size: 20px;
          margin-right: 12px;
        }

        .section-title {
          font-size: 16px;
          font-weight: 600;
          color: #2c3e50;
        }
      }

      .settings-list {
        .van-cell {
          padding: 16px;

          &:not(:last-child) {
            border-bottom: 1px solid #f5f5f5;
          }

          &__title {
            font-size: 15px;
            font-weight: 500;
            color: #2c3e50;
          }

          &__label {
            font-size: 13px;
            color: #7f8c8d;
            margin-top: 4px;
          }
        }
      }
    }

    .settings-tips {
      background: white;
      border-radius: 16px;
      padding: 20px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

      .tips-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: 600;
          color: #2c3e50;
          margin-left: 8px;
        }
      }

      .tips-content p {
        font-size: 13px;
        color: #7f8c8d;
        line-height: 1.6;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
